const enigma = require('enigma.js');
const schema = require('enigma.js/schemas/12.170.2.json');
const SenseUtilities = require('enigma.js/sense-utilities');

const config = {
  host: 'sense-demo.qlik.com',
  appId: '91b224d7-f300-423e-858b-17b399a08820', // 5e6cb61f-799d-4b9c-8d24-abf03894804e
  // host: 'sense-demo-staging.qlik.com',
  // appId: '91b224d7-f300-423e-858b-17b399a08820',
};
const url = SenseUtilities.buildUrl(config);
const session = enigma.create({ schema, url });

export default session.open().then((global) => global.openDoc(config.appId));
